import { jsxs, jsx } from 'react/jsx-runtime';
import { Component, createRef } from 'react';
import cn from 'classnames';
import Time from 'timen';
import S from './Label.styl.js';
import { getLabelClipPath } from './Label.helpers.js';

class Label extends Component {
    gapWrapRef = createRef();
    gapRef = createRef();
    timers;
    state = { clipPath: '' };
    labelWidth = 0;
    static defaultProps = {
        size: 'm',
    };
    constructor(props) {
        super(props);
        this.timers = Time.create();
    }
    componentDidMount() {
        this.updateClipPath();
    }
    componentDidUpdate(prevProps) {
        const { children, isOnTop, size, onClipPathChange } = this.props;
        const needUpadte = onClipPathChange &&
            (children !== prevProps.children ||
                isOnTop !== prevProps.isOnTop ||
                size !== prevProps.size);
        if (needUpadte)
            this.updateClipPath();
    }
    updateClipPath = () => {
        const { isOnTop, onClipPathChange, size } = this.props;
        const gapWrapElem = this.gapWrapRef?.current;
        const gapElem = this.gapRef?.current;
        if (!onClipPathChange || !gapWrapElem || !gapElem)
            return;
        // @ts-ignore
        const { offsetLeft } = gapWrapElem;
        const { offsetWidth } = gapElem;
        const labelWidth = isOnTop ? offsetWidth : 0;
        if (this.labelWidth === labelWidth)
            return;
        this.labelWidth = labelWidth;
        const clipPath = getLabelClipPath(offsetLeft, labelWidth, size);
        onClipPathChange(clipPath);
    };
    render() {
        const { className, size, isOnTop, isError, children } = this.props;
        const classes = cn(S.root, S[`size-${size}`], isOnTop && S.onTop, isError && S.isError, className);
        if (!children)
            return null;
        return (jsxs("div", { className: classes, children: [jsx("div", { className: S.view, children: jsx("div", { children: children }) }), jsx("div", { className: S.gapWrap, ref: this.gapWrapRef, children: jsx("div", { className: S.gap, ref: this.gapRef, children: children }) })] }));
    }
}

export { Label };
